<template>
    <div class="login-page">
        <Announcements />
        <!-- Navbar -->
        <nav class="navbar navbar-expand-lg navbar-absolute fixed-top navbar-transparent">
            <div class="container pt-20">
                <div class="navbar-wrapper w-100">
                    <a class="navbar-brand w-100" href="https://www.bigscoots.com/" target="_blank">
                        <img src="../assets/img/bigscoots-logo/logo_light.svg" alt="Bigscoots" width="70%" class="center login-bs-logo">
                    </a>
                </div>
            </div>
        </nav>
        <!-- End Navbar -->
        <div class="wrapper wrapper-full-page ">
            <div class="full-page section-image">
                <div class="content" style="z-index: 1000">
                    <div class="container">
                        <div class="col-lg-4 col-md-6 ml-auto mr-auto">
                            <div class="card"  v-if="!loading">
                                <!-- Show the loader when async operation is going on -->
                                <div class="loader"></div>
                            </div>
                            <form v-else class="form" @submit.prevent="solveReCaptcha()">
                                <div class="card card-login">
                                    <div class="card-header ">
                                        <div class="card-header ">
                                            <h3 class="header text-center">Login</h3>
                                        </div>
                                    </div>
                                    <div class="card-body ">
                                        <div class="form-group input-group">
                                            <div class="input-group-prepend">
                        <span class="input-group-text">
                          <i class="nc-icon nc-email-85"></i>
                        </span>
                                            </div>
                                            <input type="email" required class="form-control" placeholder="Registered Email" v-model="email">
                                        </div>
                                        <div class="form-group input-group mb-2">
                                            <div class="input-group-prepend">
                        <span class="input-group-text">
                          <i class="nc-icon nc-key-25"></i>
                        </span>
                                            </div>
                                            <input type="password" required placeholder="Password" class="form-control" v-model="password">
                                        </div>
<!--                                        <div class="custom-control custom-checkbox d-flex  mb-2">-->
<!--                                            <input type="checkbox" class="custom-control-input"  name="identifiers" v-on:change="updateRememberCoumputer()" v-model="remember_computer" :value="!remember_computer" id="remember_computer"/>-->
<!--                                            <label class="custom-control-label " for="remember_computer">Remember computer for 30 days</label>-->
<!--                                        </div>-->
<!--                                        <div id="recaptcha"></div>-->
                                        <vue-recaptcha ref="recaptcha" size="invisible" sitekey="6Ld9HecUAAAAAA4N-8PQXtVTTqq4GJ-I_A8_WWU1" @verify="onVerifyReCaptcha" @expired="onExpiredReCaptcha"></vue-recaptcha>
                                        <p class="text-danger text-center mb-0" v-if="feedback"><strong>{{ feedback }}</strong></p>
                                    </div>
                                    <div class="card-footer ">
                                        <button type="submit" class="btn btn-warning btn-round btn-block mb-3" :disabled="disableLoginBtn">{{ loginBtnText }}</button>
                                        <p class="mb-0 text-center" style="font-size: 12px;">
                                            <router-link tag="a" :to="{ name: 'forgotPassword' }">Forgot Password?</router-link>
                                        </p>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
                <footer class="footer footer-black  footer-white ">
                    <div class="container-fluid">
                        <div class="row">
                            <nav class="footer-nav">
                                <ul>
                                    <li>
                                        <a href="https://www.bigscoots.com/" target="_blank">Bigscoots</a>
                                    </li>
                                    <li>
                                        <a href="https://www.bigscoots.com/wordpress-optimized-hosting/" target="_blank">WordPress Hosting</a>
                                    </li>
                                    <li>
                                        <a href="https://www.bigscoots.com/about-us/privacy-policy" target="_blank">Privacy Policy</a>
                                    </li>
                                    <li>
                                        <a href="https://www.bigscoots.com/about-us/privacy-policy" target="_blank">SLA</a>
                                    </li>
                                </ul>
                            </nav>
                            <div class="credits ml-auto">
<!--                                <span class="copyright">-->
<!--                                  ©-->
<!--                                  {{ currentYear }}, made with-->
<!--                                  <i class="fa fa-heart heart"></i> by <a href="https://acnam.com" class="text-light" target="_blank">Acnam</a>-->
<!--                                </span>-->
                            </div>
                        </div>
                    </div>
                </footer>
                <div class="full-page-background"></div>
            </div>
        </div>
    </div>
</template>

<script>
    import $ from 'jquery'
    import { db, auth } from '@/firebase/init'
    import swal from 'sweetalert2';
    import VueRecaptcha from 'vue-recaptcha';
    import axios from 'axios';
    export default {
        name: "Login",
        data() {
            return {
                captchaVerified: false,
                captchaToken: '',
                loading: false,
                email: null,
                password: null,
                feedback: null,
                loginBtnText: 'Get Started',
                disableLoginBtn: false,
                remember_computer:true
            }
        },
        components: {
            VueRecaptcha,
            Announcements: () => import(/* webpackChunkName: "userMenu" */ "../components/Helps/Announcements.vue"),
        },
        computed: {
            currentYear() {
                return new Date().getFullYear()
            }
        },
        mounted() {
            // this.captchaVerified = new firebase.auth.RecaptchaVerifier('recaptcha');
            // this.captchaVerified.render();
            // this.captchaVerified.verify().then(resp => {
            //     this.login();
            // });
            document.body.classList.add('login-page')
            $('.form-control').on("focus", function() {
                $(this).parent('.input-group').addClass("input-group-focus");
            }).on("blur", function() {
                $(this).parent(".input-group").removeClass("input-group-focus");
            });
        },
        beforeDestroy() {
            document.body.classList.remove('login-page')
        },
        created () {
            this.loading = true
        },
        methods: {
            updateRememberCoumputer(){
                console.log(this.remember_computer);
                this.$store.dispatch("setRememberComputer",this.remember_computer );
            },
            onVerifyReCaptcha (response) {
                console.log('Verified');
                this.captchaToken = response;
                this.captchaVerified = true;
                this.login();
            },
            onExpiredReCaptcha () {
                console.log('Captcha Expire');
                this.captchaVerified = false;
            },
            solveReCaptcha () {
                // Disable the login button
                this.disableLoginBtn = true;

                // Change login button text
                this.loginBtnText = 'Logging you in...';

                // Set error feedback to null
                this.feedback = null

                this.$refs.recaptcha.execute();
            },
            async login () {
                if(!this.captchaVerified){
                    swal('Invalid Captcha', 'Please solve captcha first!', 'error');
                    return;
                }


                // Pass the login details to firebase to login the user
                const captchaResp = await axios.post('https://api-dev.bigscoots.com/captcha/verify', {
                    response: this.captchaToken,
                    grant_type: 'token',
                });
                console.log('Captcha Status: ' + captchaResp.status);
                if(captchaResp.status === 403){
                    swal('Error!', 'Invalid Captcha Solution!', 'error');
                    this.captchaVerified = false;
                    this.$refs.recaptcha.reset(); // Direct call reset method
                    // Enable the login button
                    this.disableLoginBtn = false;

                    // Change login button text to Default
                    this.loginBtnText = 'Get Started';
                    return false;
                }

                auth.signInWithEmailAndPassword(this.email, this.password)
                    .then(() => {
                        // The login is successful. Now lets check the details from the database about this user to see if he is an admin or not
                        this.getLoggedUser(auth.currentUser.uid);
                    }).catch(err => {
                        this.captchaVerified = false;
                        this.$refs.recaptcha.reset(); // Direct call reset method
                        // Enable the login button
                        this.disableLoginBtn = false;

                        // Change login button text to Default
                        this.loginBtnText = 'Get Started';

                        // Show error
                        this.feedback = err.message
                        this.addLog({
                            name: "Problem with login user: " + this.email,
                            message: err.message,
                            level:  "danger"
                        })
                })
            },
            getLoggedUser(uid){
                console.log('Fetching User Info...');
                db.collection('users').doc(uid).get()
                    .then(doc => {
                        // Check if the document exists - then do more checks; Else throw error
                        if(doc.exists && doc.data().userType !== 'normal') {
                            const user = {
                                firstName: doc.data().firstName,
                                lastName: doc.data().lastName,
                                email: doc.data().email,
                                userType: doc.data().userType,
                                customerID: doc.data().customerID ? doc.data().customerID : null,
                                uid: doc.id,
                                signature: doc.data().signature || '',
                                hbName: doc.data().hbName || '',
                                notifications: doc.data().notifications ? doc.data().notifications : false,
                                muteNoti: (doc.data().muteNotiFlag !== undefined) ? doc.data().muteNotiFlag : true,
                                twoFA:doc.data().twoFA,
                                isEmailSetup: doc.data().emailSetupFlag,
                                stopStatusCake: doc.data().stopStatusCake,
                                getNotificationStatus: (doc.data().getNotificationStatus ===undefined) ? false : doc.data().getNotificationStatus,
                                fcmToken : doc.data().fcmToken
                            };

                            this.$store.dispatch('updateUserDetails', user);


                            if(!user.twoFA){
                                // Store the received data about the user in the Local Storage
                                localStorage.setItem('userDtls', JSON.stringify(user));
                                // Also dispatch the details to Vuex store
                                auth.currentUser.getIdToken().then((idToken)=>{
                                    this.$store.dispatch('updateUserDetails', {...user, idToken: idToken})
                                    localStorage.setItem('userDtls', JSON.stringify({...user, idToken: idToken}))
                                });

                                this.$store.dispatch("customer/allDetailsUpdate", {...doc.data(), uid: doc.id, docID: doc.id});

                                // set a cookie for 24hours if user does not have 2FA
                                this.$cookie.set('login-session', true, { expires: '24h' });


                                // Check what kind of a user is this by checking userType of the received data
                                // if userType === admin then redirect to admin page
                                if(user.userType === 'admin' || user.userType === 'manager') {

                                    this.$router.push({ name: 'betteruptime' });
                                    // Enable the login button
                                    this.disableLoginBtn = false;

                                    // Change login button text to Default
                                    this.loginBtnText = 'Get Started';
                                } else {
                                    this.$router.push({ name: 'userDashboard' });
                                    // Enable the login button
                                    this.disableLoginBtn = false;

                                    // Change login button text to Default
                                    this.loginBtnText = 'Get Started';
                                }
                                this.addLog({
                                    name: user.firstName + " " + user.lastName,
                                    message: "Logged in",
                                    level:  "info"
                                })
                            }else{
                                this.$router.push('/two-fa');
                            }
                        } else {
                          auth.signOut().then(async () => {
                            this.$cookie.delete('rememberComputer');
                            this.$cookie.delete('defaultLogin');
                            localStorage.removeItem("userDtls");
                            localStorage.removeItem('adminToken');
                            localStorage.removeItem('adminDtls');
                            localStorage.removeItem('accounts');
                            localStorage.removeItem('customers');
                          });
                            this.feedback = "No info available about this user in DB. SOL: DelUserManually"
                            // Enable the login button
                            this.disableLoginBtn = false;

                            // Change login button text to Default
                            this.loginBtnText = 'Get Started';
                            this.addLog({
                                name: "Problem with login user: " + this.email,
                                message: this.feedback,
                                level:  "danger"
                            })
                        }
                    })
                    .catch(err => {
                        // Enable the login button
                        this.disableLoginBtn = false;

                        // Change login button text to Default
                        this.loginBtnText = 'Get Started';

                        // Show error
                        this.feedback = err.message;
                        this.addLog({
                            name: "Anonymous",
                            message: err.message,
                            level:  "danger"
                        })
                    })
            }
        }
    }
</script>

<style lang="scss">
    .login-page {
        .full-page-background {
            background-image: url('../assets/img/bg/fabio-mangione.jpg');
        }
        .section-image{
            &:after {
                background-color: rgba(90, 124, 253, 0.94)
            }
        }
        .login-bs-logo {
            max-height: 60px;
        }
    }
</style>

